import type { ClassDef } from '@keystone/sim';
import { blademaster } from './blademaster';
import { lightbinder } from './lightbinder';
import { stormcaller } from './stormcaller';
import { warden } from './warden';

import { BASE_CLASSES } from './bases';

export { blademaster, lightbinder, stormcaller, warden };
export { BASE_AURAS, BASE_CLASSES, BASE_CLASS_ART, BASE_SPECS, acolyte, mage, ranger, rogue, warrior, type SpecPreview } from './bases';
import { BASE_VISUAL_ALIAS as BASE_ONLY_ALIAS } from './bases';
import { SPEC_ABILITIES } from './specs/index';
export * from './specs/index'; // +specs

/**
 * New ability id → old ability whose icon / VFX / clip it reuses (from `ui.animAs`): the base kits
 * and every spec ability (+specs).
 */
export const BASE_VISUAL_ALIAS: Readonly<Record<string, string>> = {
  ...BASE_ONLY_ALIAS,
  ...Object.fromEntries(SPEC_ABILITIES.flatMap((a) => (a.ui?.animAs ? [[a.id, a.ui.animAs]] : []))),
};

/** The retired M+ kits (legacy harness / M+ tooling), in party slot order (tank, healer, melee, ranged). */
export const LEGACY_CLASSES: ClassDef[] = [warden, lightbinder, blademaster, stormcaller];

/**
 * Every class in the bundle: the five playable bases first, then the retired kits (still compiled
 * for the legacy M+ harness and its tests).
 */
export const CLASSES: ClassDef[] = [...BASE_CLASSES, ...LEGACY_CLASSES];
